import React, { useEffect, useState } from "react";
import classNames from "classnames";

import { photoUrl } from "../../../config";
import BookingNumberVariant from "./BookingNumberVariant";
import ArrUpIcon from "../../ui/ArrUpIcon";

import "./bookingDesignVariants.scss";

function BookingDesignVariants({
  props,
  is_opened = false,
  is_preview = false, // отображать превью первого/единственного номера без возможности выбирать
  set_number,
  selected_number = null,
}) {
  // если номер выбран - устанавливаем его данные для отображения
  const [selectedNumber, setSelectedNumber] = useState(
    selected_number ? props.numbers.find((f) => f.id == selected_number) : null,
  );
  const [opened, setOpened] = useState(is_opened);

  useEffect(() => {
    // console.log("selectedNumber", selectedNumber);
  }, [selected_number]);

  const toggle = () => {
    setOpened((prev) => !prev);
  };

  const selectHandler = (id) => {
    if (selectedNumber && props.numbers?.length == 1) {
      // если всего один вариант - не позволяем снять выбор
      return;
    }
    setOpened(false);
    set_number(id);
    if (id && props.numbers?.length > 0) {
      setSelectedNumber(props.numbers.find((f) => f.id == id));
    } else {
      setSelectedNumber(null);
    }
  };

  const getPhotoUrl = () => {
    if (selectedNumber && selectedNumber.photos?.length > 0) {
      return `${photoUrl}/${props.photo_url}/numbers/${selectedNumber.photos[0]}.jpg`;
    }
    return "/empty.jpg";
    // return `${photoUrl}/${props.photo_url}/numbers/${props.s_preview}.jpg`;
  };

  if (is_preview) {
    return (
      <div className={classNames("bookingVariants mb6", { opened })}>
        <div className="dfsp dfa gap5">
          {!opened && (
            <div className="bookingVariants__photo">
              <img src={getPhotoUrl()} alt="" />
            </div>
          )}
          <div className="bookingVariants__title">
            {selectedNumber
              ? selectedNumber.title
              : "Выберите вариант дизайна номера"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames("bookingVariants mt6", { opened })}>
      <div className="dfsp dfa gap5 curp" onClick={toggle}>
        {!opened && (
          <div className="bookingVariants__photo">
            <img src={getPhotoUrl()} alt="" />
          </div>
        )}
        <div className="bookingVariants__title">
          {selectedNumber
            ? selectedNumber.title
            : "Выберите вариант дизайна номера"}
        </div>
        <div className="bookingVariants__arrow">
          <ArrUpIcon w={12} h={7} />
        </div>
      </div>
      {opened && (
        <div className="bookingVariants__list mt12">
          <p className="gray">
            Выберите предпочитаемый вариант и собственник учтёт ваши пожелания
            или нажмите кнопку «Далее»
          </p>
          {props.numbers.map((number) => (
            <BookingNumberVariant
              key={`nv_${number.id}`}
              {...number}
              url={`${photoUrl}/${props.photo_url}/numbers`}
              is_selected={selected_number == number.id}
              setNumber={selectHandler}
              freeze={props?.numbers?.length == 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default BookingDesignVariants;
